export function buildIdentityServerUrls(baseUrl: string) {
  return {
    connectToken: `${baseUrl}/connect/token`,
    jwks: `${baseUrl}/.well-known/openid-configuration/jwks`,
    userInfo: `${baseUrl}/connect/userinfo`,
    sessionCheck: `${baseUrl}/api/session-check`,
    forgotPassword: `${baseUrl}/api/forgot-password`,
    createAnalystAccount: `${baseUrl}/Account/CreateARConnectAnalystAccount`,
    createParticipantAccount: `${baseUrl}/Account/CreateARConnectParticipantAccount`,
  } as const;
}

export function buildCreateAnalystAccountUrl(baseUrl: string, token: string): string {
  const createAnalystAccountUrl = buildIdentityServerUrls(baseUrl).createAnalystAccount;
  return `${createAnalystAccountUrl}?token=${token}`;
}

export function buildCreateParticipantAccountUrl(baseUrl: string, token: string): string {
  const createParticipantAccountUrl = buildIdentityServerUrls(baseUrl).createParticipantAccount;
  return `${createParticipantAccountUrl}?token=${token}`;
}
